export const wrapRangeWithElement = (document: Document, range: Range, tagName: string): HTMLElement | null => {
    if (range.collapsed) return null;

    const wrapper = document.createElement(tagName);
    try {
        range.surroundContents(wrapper);
        return wrapper;
    } catch {
        wrapper.appendChild(range.extractContents());
        range.insertNode(wrapper);
        return wrapper;
    }
};
